/**
 * JSON.stringify that survives circular refs (falls back to empty string).
 */
// eslint-disable-next-line import/prefer-default-export
export function safeStringify(obj) {
    try {
        return JSON.stringify(obj ?? null);
    } catch {
        return '';
    }
}
